import { render, staticRenderFns } from "./AvisDeVirementLignes.vue?vue&type=template&id=587e2a40"
import script from "./AvisDeVirementLignes.vue?vue&type=script&lang=ts"
export * from "./AvisDeVirementLignes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports